import { connectorsByIdentifier } from ".";

// GitHub's user-OAuth and PAT variants could authenticate git over HTTP, but
// the GitHub App is strictly better there (webhooks, PR tracking, repo-scoped
// installs), so git sync steers GitHub to it exclusively.
const EXCLUDED_IDENTIFIERS = new Set(["github", "githubToken"]);

// Any HTTP connector can back git sync: the transport speaks git's smart HTTP
// protocol and the proxy injects whatever credential the connector defines.
// Whether the server accepts that credential on its git endpoints is between
// the user and their server; a mismatch surfaces as a sync error.
export function supportsGitAuth(identifier: string): boolean {
  if (EXCLUDED_IDENTIFIERS.has(identifier)) return false;
  return connectorsByIdentifier[identifier]?.protocol === "http";
}

// GitHub Apps register their webhook at app creation; GitLab hooks are added
// per project by hand. Other connectors have no webhooks at all.
const MANUAL_WEBHOOK_IDENTIFIERS = new Set(["gitlab", "gitlabOAuth"]);

export function supportsManualGitWebhook(identifier: string): boolean {
  return MANUAL_WEBHOOK_IDENTIFIERS.has(identifier);
}

// Providers with pull or merge requests 3B can link to and track.
const PULL_REQUEST_IDENTIFIERS = new Set([
  "githubApp",
  "gitlab",
  "gitlabOAuth",
]);

export function supportsPullRequests(identifier: string): boolean {
  return PULL_REQUEST_IDENTIFIERS.has(identifier);
}
